import { useHistory } from "@/app/hooks/useHistory";

import defaultImage from "../../../assets/images/img-upload-default.png";
const PropertyCard = ({ property }) => {
  const history = useHistory();
  const handleClickOnProperty = () => {
    history.push(`/Property/SaveProperty?ID=${property.propertyID}`);
  };
  return (
    <div className="property-card-container" onClick={handleClickOnProperty}>
      <div className="property-card">
        {/* Property Image */}
        <img src={property.photoURL || defaultImage} alt="Property" className="property-image" />

        {/* Property Content */}
        <div className="property-details">
          <p className="property-location">
            {property.webRef || property.title || property.cityOrTown
              ? `${property.webRef ? property.webRef + ": " : ""}${property.title ? property.title : ""}${property.cityOrTown ? ", " + property.cityOrTown : ""}`
              : "No data available"}
          </p>

          <p className="property-info">
            {property.price
              ? `${property.price}${property.saleType ? " | " + property.saleType : ""}${property.status ? " | " + property.status : ""}${property.mandate ? " | " + property.mandate : ""}`
              : property.saleType || property.status || property.mandate
                ? `${property.saleType ? property.saleType : ""}${property.status ? " | " + property.status : ""}${property.mandate ? " | " + property.mandate : ""}`
                : ""}
          </p>

          <p className="property-agent">{property.agentNames || null}</p>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
